
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/study-abroad-association",
      function () {
        return require("private-next-pages/partners/study-abroad-association.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/study-abroad-association"])
      });
    }
  